import { render } from "./RoundBtn.vue?vue&type=template&id=325879a4"
import script from "./RoundBtn.vue?vue&type=script&lang=js"
export * from "./RoundBtn.vue?vue&type=script&lang=js"

import "./RoundBtn.vue?vue&type=style&index=0&id=325879a4&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__